var render = function render(_c,_vm){return _c('mm-alert',{attrs:{"type":"info","closable":false,"global":"","center":"","show-icon":""}},[_c('span',{directives:[{name:"t",rawName:"v-t",value:('message.auth.pending'),expression:"'message.auth.pending'"}],attrs:{"slot":"title"},slot:"title"})])
}
var staticRenderFns = []

export { render, staticRenderFns }